export type InfoModalType = 'text' | 'map';
